import intl from 'react-intl-universal';
import classnames from 'classnames';

const VendorsTableHead = () => {
  const headCellsClassNames = 'py-3 font-semibold';

  return [
    {
      'data-cy': 'head_vendor-name',
      columnName: 'vendorName',
      content: intl.get('VENDORS_PAGE.TABLE.HEAD.VENDOR_NAME'),
      className: classnames(headCellsClassNames, 'w-3/12'),
    },
    {
      'data-cy': 'head_vendor-description',
      columnName: 'description',
      content: intl.get('VENDORS_PAGE.TABLE.HEAD.DESCRIPTION'),
      className: classnames(headCellsClassNames, 'w-3/12'),
    },
    {
      'data-cy': 'head_vendor-country',
      columnName: 'country_iso_3166_1_alpha_2_code',
      content: intl.get('VENDORS_PAGE.TABLE.HEAD.COUNTRY'),
      className: headCellsClassNames,
    },
    {
      'data-cy': 'head_vendor-location',
      columnName: 'data.province',
      content: intl.get('VENDORS_PAGE.TABLE.HEAD.LOCATION'),
      className: headCellsClassNames,
    },
    {
      'data-cy': 'head_vendor-creation',
      columnName: 'createdAt',
      content: intl.get('VENDORS_PAGE.TABLE.HEAD.CREATION_DATE'),
      className: headCellsClassNames,
    },
    {
      'data-cy': 'head_vendor-enabled',
      columnName: 'enabled',
      content: intl.get('VENDORS_PAGE.TABLE.HEAD.ENABLED'),
      className: headCellsClassNames,
    },
  ];
};

export default VendorsTableHead;
